module.exports = __webpack_public_path__ + "static/media/hide_wallet_balance.96ff4c51.svg";